import axios from 'axios';

export default function managePortfolios(portfolioData, config) {
  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    Authorization: `Bearer ${localStorage.getItem('jwtToken')}`,
    'x-location-id': localStorage.getItem('locationId')
  };
  const url = config.managePortfolios;
  return dispatch => dispatch({
    type: 'ADD_EDIT_PORTFOLIOS_SAVE',
    payload: axios({ method: 'post', url, headers, data: { portfolioData } })
  })
}


// WEBPACK FOOTER //
// ./src/actions/VXC/managePortfolios.js